import { render, staticRenderFns } from "./ControlsIframe.vue?vue&type=template&id=565081ff&scoped=true&"
import script from "./ControlsIframe.vue?vue&type=script&lang=js&"
export * from "./ControlsIframe.vue?vue&type=script&lang=js&"
import style0 from "./ControlsIframe.vue?vue&type=style&index=0&id=565081ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565081ff",
  null
  
)

export default component.exports